import { render } from "./협력 병의원 체결 절차.vue?vue&type=template&id=4b9607ca"
import script from "./협력 병의원 체결 절차.vue?vue&type=script&lang=js"
export * from "./협력 병의원 체결 절차.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__